import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import CompanyAccountSettingsConstants from './constants';
import CompanyAccountSettingsRecord from './CompanyAccountSettingsRecord';
import type { CompanyAccountActions } from './actions.types';

function getInitialState() {
  return new CompanyAccountSettingsRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<CompanyAccountSettingsRecord, CompanyAccountActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT_REQUEST:
      return state.setLoading(true).merge({
        loadError: undefined,
      });

    case CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT_REQUEST_SUCCESS: {
      const { fleetAccount, showSubscriptionAccount, subscriptionAccount } = action.response;

      return state
        .setLoading(false)
        .setFleetAccount(fleetAccount)
        .setSubscriptionAccount(subscriptionAccount)
        .merge({
          showSubscriptionAccount,
        });
    }

    case CompanyAccountSettingsConstants.GET_COMPANY_ACCOUNT_REQUEST_ERROR:
      return state.setLoading(false).merge({
        loadError: new ErrorRecord(action.error),
      });

    case CompanyAccountSettingsConstants.EDIT_INVOICE_ADDRESS_REQUEST:
      return state.merge({
        isSubmitting: true,
        isSubmitted: false,
        submitError: undefined,
      });

    case CompanyAccountSettingsConstants.EDIT_INVOICE_ADDRESS_REQUEST_SUCCESS:
      return state.merge({
        isSubmitting: false,
        isSubmitted: true,
      });

    case CompanyAccountSettingsConstants.EDIT_INVOICE_ADDRESS_REQUEST_ERROR:
      return state.merge({
        isSubmitting: false,
        submitError: new ErrorRecord(action.error),
      });

    case CompanyAccountSettingsConstants.RESET_FORM:
      return getInitialState();

    default:
      return state;
  }
};

export default reducer;
